import { useAtom } from 'jotai';

import { SidebarAccordionTemplate } from '@/components/templates/sidebar-accordion-template';
import { useAutoExpandSearch } from '@/features/trends/components/selections-sidebar/hooks/use-auto-expand-search';
import { useSelectionGroups } from '@/features/trends/components/selections-sidebar/hooks/use-selection-groups';
import SelectionState from '@/features/trends/components/selections-sidebar/state/selections.state';

import { EmptySelectionsList } from './empty-selections-list';
import { SelectionsListGrouping } from './selections-list-grouping';

export const SelectionsList = () => {
  const [expandedSectionIds, setExpandedSectionIds] = useAtom(SelectionState.expandedSectionIds);
  const selectionGroups = useSelectionGroups();

  useAutoExpandSearch(selectionGroups);

  return (
    <SidebarAccordionTemplate
      state={{
        items: selectionGroups,
        expanded: expandedSectionIds,
        setExpanded: setExpandedSectionIds,
      }}
      keyGenerator={(item) => item.value}
      contentComponent={SelectionsListGrouping}
      emptyComponent={EmptySelectionsList}
    />
  );
};
